<div class="py-2">
  <label [for]="id" class="block font-medium text-gray-700 dark:text-gray-200  font-auth mb-1">
    {{ label }}
  </label>

  <div class="flex items-center border border-[#D4D4D8] rounded-xl px-3 bg-white dark:bg-[#52525B]">
    <p-select
      [options]="countries"
      [(ngModel)]="selectedCountry"
      optionLabel="name"
      placeholder="Select country"
      (onChange)="onCountryChange()"
      class="w-36 mr-2 !border-0 outline-none shadow-none !focus:ring-0 !focus:outline-none"
    >
      <!-- قائمة الاختيارات -->
      <ng-template let-country pTemplate="item">
        <div class="flex items-center">
          <img [src]="country.flagUrl" class="w-6 h-4 mr-2 dark:placeholder-white rounded-sm" />
          <span>{{ country.name }} ({{ country.dialCode }})</span>
        </div>
      </ng-template>

      <!-- العنصر المختار -->
      <ng-template let-country pTemplate="selectedItem">
        <div class="flex items-center">
          <img [src]="country.flagUrl" class="w-6 h-4 dark:placeholder-white mr-2 rounded-sm" />
          <span class="me-5">{{ country.dialCode }}</span>
        </div>
      </ng-template>
    </p-select>

    <input
      pInputText
      [id]="id"
      type="tel"
      [placeholder]="selectedCountry.placeholder"
      [ngModel]="value"
      [disabled]="disabled"
      (input)="onValueChange($event)"
      (blur)="onBlur()"
      class="w-full px-3 py-2 text-sm !border-0 placeholder-gray-400 focus:ring-0 focus:outline-none"
    />
  </div>
</div>
